import { useContext, useState, useEffect } from "react";
import ChangelogComponent from "manifest-components/src/Changelog";
import { ChangelogType } from "manifest-components/src/Changelog/typings";
import { convertVersionStringToNumber } from "manifest-components/src/Changelog/helper";

import { VersionContext } from "../../context/Version/versionProvider";

const hardCodedNotes: ChangelogType[] = [
  {
    date: "December 15, 2023",
    version: "1.8.472",
    changes: ["Add Finch integration"],
  },
  {
    date: "November 20, 2023",
    version: "1.8.455",
    changes: ["Add investment document upload options in plan details setup"],
  },
  {
    date: "May 12, 2023",
    version: "1.8.373",
    changes: ["Add changelog page to the app. User can access the change log for app updates."],
  },
  {
    date: "Mar 3, 2023",
    version: "1.8.12",
    changes: [
      "Add security page in resources page. User can access security page to learn more about security features in the app.",
      "Make upload plan document optional. User can skip uploading plan document during onboarding process.",
    ],
  },
  {
    date: "Sept 21, 2022",
    version: "1.8.0",
    changes: ["Add calendly to set up meeting with account manager during onboarding process."],
  },
];

const ChangelogPage = () => {
  const { currentVersion } = useContext(VersionContext);
  const [notes, setNotes] = useState<ChangelogType[]>([]);

  useEffect(() => {
    const version = currentVersion === "1.0.0" || !currentVersion ? "1.8.371" : currentVersion;
    const filteredNotes = hardCodedNotes.filter(
      (note) => convertVersionStringToNumber(note.version) <= convertVersionStringToNumber(version)
    );
    setNotes(filteredNotes);
  }, [currentVersion]);

  return <ChangelogComponent notes={notes} />;
};

export default ChangelogPage;
